import { useState } from 'react';

export type LatestCell<T> = {
  readonly get: () => T;
  readonly set: (next: T) => void;
};

export const latestCell = <T>(initial: T): LatestCell<T> => {
  let current = initial;
  return {
    get: () => current,
    set: (next: T) => {
      current = next;
    },
  };
};

export const useLatestCell = <T>(initial: T) => {
  const [cell] = useState(() => latestCell(initial));
  return cell;
};
